import { createSelector } from 'reselect';

import {
    getFullPath,
    removeAllHTMLAndUnicodeSymbols,
} from '../../../helpers/helpers';
import { PostReduxType } from '../../post/types';
import { RubricPostSelectorOmitType } from '../types';

const rubrics = (state: {
    rubrics: {
        rubrics: PostReduxType[];
        title: string;
        postsAllNumber: number;
    };
}) => state.rubrics;

export const rubricsSelector = createSelector(
    [rubrics],
    ({ rubrics, postsAllNumber, title }) => {
        let data: RubricPostSelectorOmitType = [];

        if (rubrics) {
            rubrics.map((post: PostReduxType) => {
                let slugParent = post.slugParent,
                    object = {
                        id: post.id,
                        image: post.images.large || '',
                        title: removeAllHTMLAndUnicodeSymbols(
                            post.title.rendered
                        ),
                        slug: getFullPath(['posts', slugParent, post.slug]),
                        description: removeAllHTMLAndUnicodeSymbols(
                            post.excerpt.rendered
                        ),
                    };

                data.push(object);
            });
        }

        const buttons = [
            { name: 'Все', id: '0' },
            { name: 'Популярные', id: '1' },
        ];

        return { posts: data, count: postsAllNumber, title, buttons };
    }
);
